export default "__VITE_ASSET__CKyoSFIX__"